// extracted by mini-css-extract-plugin
export var centered = "tag-list-module--centered--CzZrJ";
export var item = "tag-list-module--item--EH4Mx";
export var list = "tag-list-module--list--lI9EZ";